import axios from 'axios';
import moment from "moment";

export const RESET_DATA = 'RESET_DATA';
export const STORE_PERSON_DATA = 'STORE_PERSON_DATA';
export const STORE_CONTACT_DATA = 'STORE_CONTACT_DATA';
export const GET_ADDRESS = 'GET_ADDRESS';
export const GET_INFO = 'GET_INFO';
export const VALIDATE_PERSON = 'VALIDATE_PERSON';
export const SEND_NOTIFICATION = 'SEND_NOTIFICATION';
export const CLEANUP_ADDRESS = 'CLEANUP_ADDRESS';
export const SET_NOT_A_ROBOT = 'SET_NOT_A_ROBOT';

export const getInfo = () => ({
  type: GET_INFO,
  payload: {
    promise: axios
      .get(`${process.env.REACT_APP_BASE_URL}/help`)
      .then(response => response)
  }
});


export const getAddress = (addressString) => ({
  type: GET_ADDRESS,
  payload: {
    promise: axios
      .get(`${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_GET_ADDRESS_URL}?q=${addressString}`)
      .then(response => response)
  }
});

export const cleanupAddresses = () => ({
  type: CLEANUP_ADDRESS,
  payload: {}
});

export const setNotARobot = (val) => ({
  type: SET_NOT_A_ROBOT,
  payload: {notARobot: val}
});

export const validatePerson = (firstname, middlename, lastname, birth, death) => {
  const postData = {
    "FirstName": `${firstname || ''} ${middlename || ''}`.trim(),
    "LastName": lastname || '',
    "DateOfBirth": birth,
    "DateOfDeath": death
  };
  return {
    type: VALIDATE_PERSON,
    payload: {
      promise: axios
        .post(`${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_VALIDATE_PERSON}`, postData)
        .then(response => {
          console.log("Validate data:", postData)
          console.log("Validate result:", response)
          return response
        })
    }
  }
};

export const storePersonData = (person) => ({
  type: STORE_PERSON_DATA,
  payload: {
    ...person
  }
});

export const storeContactData = (contact) => ({
  type: STORE_CONTACT_DATA,
  payload: {...contact}
});

export const resetSearch = () => ({
  type: RESET_DATA,
  payload: {}
});

export const sendNotification = (contactData, personData, cleanupTasks) => {
  let deceasedAddress = "";
  if(personData.currentAddress.enterManually) {
    deceasedAddress = {
      "street": personData.currentAddress.addressLine,
      "suburb": personData.currentAddress.suburb,
      "state": personData.currentAddress.state ? personData.currentAddress.state.label : '',
      "postalcode": personData.currentAddress.postcode,
    }
  }
  else if (personData.currentAddress.details) {
    deceasedAddress = {
      "suburb": personData.currentAddress.details.Address.Suburb,
      "state": personData.currentAddress.details.Address.State,
      "postalcode": personData.currentAddress.details.Address.Postcode,
      "latitude": personData.currentAddress.details.Address.Latitude,
      "longitude": personData.currentAddress.details.Address.Longitude
    }

    if(personData.currentAddress.details.Address.AddressLine1) {
      deceasedAddress.street = personData.currentAddress.details.Address.AddressLine1

      if(personData.currentAddress.details.Address.BuildingName) {
        deceasedAddress.street = personData.currentAddress.details.Address.BuildingName + ' ' + deceasedAddress.street;
      }
    }
  } 
  
  let contactAddress = "";
  if(contactData.postalAddress.enterManually) {
    contactAddress = {
      "street": contactData.postalAddress.addressLine,
      "suburb": contactData.postalAddress.suburb,
      "state": contactData.postalAddress.state ? contactData.postalAddress.state.label : '',
      "postalcode": contactData.postalAddress.postcode,
    }
  }
  else if (contactData.postalAddress.details) {
    contactAddress = {
      "suburb": contactData.postalAddress.details.Address.Suburb,
      "state": contactData.postalAddress.details.Address.State,
      "postalcode": contactData.postalAddress.details.Address.Postcode,
      "latitude": contactData.postalAddress.details.Address.Latitude,
      "longitude": contactData.postalAddress.details.Address.Longitude
    }

    if(contactData.postalAddress.details.Address.AddressLine1) {
      contactAddress.street = contactData.postalAddress.details.Address.AddressLine1

      if(contactData.postalAddress.details.Address.BuildingName) {
        contactAddress.street = contactData.postalAddress.details.Address.BuildingName + ' ' + contactAddress.street;
      }
    }
  } 

  
  const request = {
    "deceasedState": personData.deceasedState,
    "certificateIssued": personData.birthCertificateIssued === "yes",
    "deathCertificateRegNumber": !personData.certificateLongNum || !personData.certificateShortNum ? 'Not provided' :
      `${personData.certificateLongNum}-${personData.certificateShortNum}`,
    "deceasedFirstName": personData.firstname,
    "deceasedMiddleName": personData.middlename,
    "deceasedLastName": personData.lastname,
    "dateOfBirth": moment(personData.birth, "YYYY-MM-DD").format('MM/DD/YYYY'),
    "dateOfDeath": moment(personData.death, "YYYY-MM-DD").format('MM/DD/YYYY'),
    "knownByOtherName": personData.otherNames === "yes",
    "otherName": personData.otherName,
    "userRole": contactData.role,
    "userRoleOther": contactData.other,
    "userFirstName": contactData.firstname,
    "userMiddleName": contactData.middlename,
    "userLastName": contactData.lastname,
    "userCompany": contactData.company,
    "userContactNumber": contactData.contactNumber,
    "userEmailAddress": contactData.emailAddress,
    "userPostalAddress": contactAddress,
    "lastKnownAddress": deceasedAddress
  };
  
  if (personData.nursingHome) {
    request.nursingHome = personData.nursingHome.value;
  }
  
  return {
    type: SEND_NOTIFICATION,
    payload: {
      promise: axios
        .post(`${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_SUBMIT}`, {request})
        .then(response => {
          cleanupTasks();
          return response;
        })
    }
  };
};
